<template>
    <div class="topDiv">
        <!-- <div style="padding-top:10px">你创建的工作地址，将加入公司的地址库中与公司同事共享</div> -->
        <div class="flex-center" style="margin-top:16px" v-if="location">
            <img src="../../assets/pcImage/icon/address.png" style="width:16px;height:16px;margin-right:15px" alt="">
            <span style="float: right; color: #8492a6;">{{location}}</span>
        </div>
        <el-form ref="form" :model="form" label-width="90px" style="margin-top:20px;">
            <el-form-item label="街道/写字楼">
                <el-select
                    style="width:75%"
                    v-model="keyword"
                    filterable 
                    remote
                    reserve-keyword
                    placeholder="请输入关键词"
                    :remote-method="remoteMethod"
                    :loading="loading"
                    @change="handleSelect">
                    <el-option
                        v-for="item in cities"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value" style="width:600px;height:80px">
                        <div class="flex-center">
                            <img src="../../assets/pcImage/icon/address.png" style="width:16px;height:16px;margin-right:15px" alt="">
                            <div>
                            <div>{{item.label}}</div>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.address }}</span>
                            </div>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="门牌号" prop="num">
                <el-input v-model="num" placeholder="输入行政区、街道、写字楼" style="width:75%"></el-input>
            </el-form-item>
        </el-form>
        <!--<label>关键词：<input v-model="keyword"></label> 
        <!--<label>地区：<input v-model="location"></label>-->
        <baidu-map class="mapStyle" ak="tbt1xnYS5nQljyTuB35nqhgpBmy7tRfp">
            <bm-view class="map"></bm-view>
            <bm-local-search :keyword="keyword" :forceLocal="true" hidden :auto-viewport="true" :location="location" @searchcomplete="searchCompleteHandler"></bm-local-search>
        </baidu-map>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button style="background:#f82b18;color:white" @click="saveHandler">保存地址</el-button>
        </div>
    </div>
</template>

<script>
import BaiduMap from "../map/components/map/Map.vue";
import BmView from "../map/components/map/MapView.vue";
import BmLocalSearch from "../map/components/search/LocalSearch"

export default {
  components: {
      BaiduMap,
      BmView,
      BmLocalSearch
  },
  props:['location'],

  data () {
    return {
      restaurants: [],
      tempSelectItem:{},
      num: '',
    //   location: '郑州',
      keyword: '',
      center: { lng: 114.888, lat: 40.797 },
      zoom: 18,
      form:{},
      cities:[],
      loading:false,
      rules:{
          street: [{ required: true, message: "请输入输入行政区、街道、写字楼", trigger: "blur" }],
          num: [{ required: true, message: "请输入门牌号", trigger: "blur" }],
      }
    }
  },
  mounted() {
  },
  methods:{
      searchCompleteHandler(e){
        if(e)
            this.restaurants = e.Hr;
      },
      handleSelect(val) {
        this.restaurants.map(item => {
            if(item.address == val)
                this.tempSelectItem = item;
        })
      },
      remoteMethod(queryString) {
        if (queryString !== '') {
          this.keyword = queryString;
          this.loading = true;
            setTimeout(() => {
                this.loading = false;
                var restaurants = this.restaurants;
                this.cities = restaurants.map(item => {
                    return { label:item.title,value:item.address,address:item.address,point:item.point };
                })
            }, 500);
        } else {
          this.options = [];
        }
      },
      close(){
          this.$emit('selectItem',{});
          this.$emit('isShow',false);
      },
      saveHandler(){
          this.$emit('selectItem',this.tempSelectItem,this.num);
          this.$emit('isShow',false);
      }
  }
}
</script>
<style land="stylus" scoped>
.flex-center{
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.topDiv{
    width: 100%;
    height: 1000px;
    padding: 10px 32px;
    background-color: white;
    text-align: left;
}
.mapStyle{
    width: 650px;
    height: 280px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
}
.map{
    width: 100%;
    height: 280px;
}
.dialog-footer{
    text-align: right;
    margin: 10px 50px 5px 0px;
}
</style>